<template>
  <v-container fluid>
    <v-card>
      <v-toolbar>
        <v-toolbar-title>Filter Courses</v-toolbar-title>
        <v-spacer />
        <v-text-field
          v-model="searchTerms"
          clearable
          flat
          solo-inverted
          hide-details
          prepend-inner-icon="mdi-magnify"
          label="Search a course or teacher"
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn icon @click="filter = !filter">
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text transition="fade-transition" v-if="filter">
        <v-row>
          <v-col cols="12" lg="4">
            <v-select
              v-model="selectedSubjects"
              :items="subjects"
              multiple
              chips
              label="Filter by Subject"
              @change="search"
            ></v-select>
          </v-col>
          <v-col cols="12" lg="4">
            <v-select
              :items="daysOfWeek"
              label="Select Days of the Week"
              multiple
              chips
            ></v-select>
          </v-col>
          <v-col cols="12" lg="4">
            <v-checkbox
              v-model="select_1on1"
              label="Individual Class "
              value="true"
              min-width="150px"
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <product-item class="my-5" v-for="prod in products" :item="prod" :key="prod.id"></product-item>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ProductItem from "../product/ProductItem.vue";

export default {
  data: () => ({
    alignment: "start",
    justify: "start",
    subjects: ["ELA", "Math"],
    selectedSubjects: ["ELA", "Math"],
    daysOfWeek: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
    searchTerms: "",
    filter: false,
  }),
  components: {
    ProductItem
  },
  computed: {
    ...mapGetters(["products"])
  },
  methods: {
    ...mapActions(["updateCart", "addMessage"]),
    addItem() {
      const order = {
        item: Object.assign({}, this.item),
        quantity: 1,
        isAdd: true
      };
      this.updateCart(order);
    },
    search() {
      // console.log("filter by subject: " + this.selectedSubjects);
      // console.log("search for " + this.searchTerms);
    }
  },
  created() {
    this.$axios
      .get("public/classroom/open-enrollment-courses")
      .then(resp => {
        this.$store.commit("Update_product_list", resp.data);
      })
      .catch(() => {
        this.addMessage("Error loading courses from server");
      });
  }
};
</script>

<style>
</style>